var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "flex flex-col max-w-xl mx-auto my-10" }, [
      _c(
        "div",
        {
          staticClass:
            "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
        },
        [
          _c("div", { staticClass: "flex flex-col" }, [
            _c(
              "div",
              {
                staticClass:
                  "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
              },
              [
                _vm.reminderConfig.metadata
                  ? _c("NotificationPreview", {
                      attrs: {
                        title: _vm.reminderConfig.metadata.title,
                        description: _vm.reminderConfig.metadata.description
                      }
                    })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "overflow-hidden rounded-md bg-white px-6 py-4 shadow"
                  },
                  [
                    _vm.reminderConfig.metadata
                      ? _c("form", { on: { submit: _vm.handleSubmit } }, [
                          _c("div", { staticClass: "space-y-12" }, [
                            _c("div", { staticClass: "pb-12" }, [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "text-base font-semibold leading-7 text-gray-900"
                                },
                                [
                                  _vm._v(
                                    " Reminder - " +
                                      _vm._s(_vm.$route.params.index + 1) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    " grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6"
                                },
                                [
                                  _c("div", { staticClass: "sm:col-span-6" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "block text-sm font-medium leading-6 text-gray-900"
                                      },
                                      [_vm._v("Title")]
                                    ),
                                    _c("div", { staticClass: "mt-2" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.reminderConfig.metadata.title,
                                            expression:
                                              "reminderConfig.metadata.title"
                                          }
                                        ],
                                        staticClass:
                                          "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 border px-2",
                                        attrs: { type: "text" },
                                        domProps: {
                                          value:
                                            _vm.reminderConfig.metadata.title
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.reminderConfig.metadata,
                                              "title",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ]),
                                  _c("div", { staticClass: "sm:col-span-6" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "block text-sm font-medium leading-6 text-gray-900"
                                      },
                                      [_vm._v("Description")]
                                    ),
                                    _c("div", { staticClass: "mt-2" }, [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.reminderConfig.metadata
                                                .description,
                                            expression:
                                              "reminderConfig.metadata.description"
                                          }
                                        ],
                                        staticClass:
                                          "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 border px-2",
                                        attrs: {
                                          id: "about",
                                          name: "about",
                                          rows: "3"
                                        },
                                        domProps: {
                                          value:
                                            _vm.reminderConfig.metadata
                                              .description
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.reminderConfig.metadata,
                                              "description",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ]),
                                  _c("div", { staticClass: "sm:col-span-6" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "block text-sm font-medium leading-6 text-gray-900"
                                      },
                                      [_vm._v("Redirect Link")]
                                    ),
                                    _c("div", { staticClass: "mt-2" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.reminderConfig.redirectUrl,
                                            expression:
                                              "reminderConfig.redirectUrl"
                                          }
                                        ],
                                        staticClass:
                                          "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 border px-2",
                                        attrs: { type: "text" },
                                        domProps: {
                                          value: _vm.reminderConfig.redirectUrl
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.reminderConfig,
                                              "redirectUrl",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mt-8 border-t border-gray-200 pt-5"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex justify-end" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "ml-3 inline-flex rounded-md shadow-sm"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "Polaris-Button Polaris-Button--primary",
                                              attrs: { type: "submit" },
                                              on: { click: _vm.save }
                                            },
                                            [_vm._m(0)]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "Polaris-Button__Content" }, [
      _c("span", { staticClass: "Polaris-Button__Text" }, [_vm._v("Save")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }